export default "__VITE_ASSET__7f6922cf__"